import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const CourseDescriptionPreview = React.memo(
  ({
    description,
    PopupComponent,
    popupTitle,
    wrapperClassName,
    paragraphClassName,
  }) => {
    const paragraphRef = useRef(null);
    const [showViewMore, setShowViewMore] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(() => {
      const el = paragraphRef.current;
      if (!el) return;

      const measure = () => {
        // +2px tolerance for subpixel rounding at 125%/150% Windows display scale
        const isOverflowing = el.scrollHeight > el.clientHeight + 2;
        setShowViewMore(isOverflowing);
      };

      // ResizeObserver fires after browser fully paints + applies CSS (line-clamp etc.)
      // Also re-measures on container resize or zoom change — no race condition
      const observer = new ResizeObserver(measure);
      observer.observe(el);

      return () => observer.disconnect();
    }, [description]);

    return (
      <div
        className={`teacherviewcoursedetails-des-wrapper ${wrapperClassName}`}
      >
        <p
          className={`teacherviewcoursedetails-des ${paragraphClassName}`}
          ref={paragraphRef}
        >
          {description}
        </p>

        {showViewMore && (
          <span
            className="view-more"
            role="button"
            tabIndex={0}
            onClick={() => setIsPopupOpen(true)}
            onKeyDown={(e) => e.key === "Enter" && setIsPopupOpen(true)}
            style={{ cursor: "pointer" }}
          >
            View More
          </span>
        )}

        {isPopupOpen && PopupComponent && (
          <PopupComponent
            title={popupTitle}
            data={description}
            onClick={() => setIsPopupOpen(false)}
          />
        )}
      </div>
    );
  },
);

CourseDescriptionPreview.displayName = "CourseDescriptionPreview";

CourseDescriptionPreview.propTypes = {
  description: PropTypes.string,
  PopupComponent: PropTypes.elementType,
  popupTitle: PropTypes.string,
  wrapperClassName: PropTypes.string,
  paragraphClassName: PropTypes.string,
};

CourseDescriptionPreview.defaultProps = {
  description: "",
  PopupComponent: null,
  popupTitle: "Description",
  wrapperClassName: "",
  paragraphClassName: "",
};

export default CourseDescriptionPreview;
